import Box from "@mui/material/Box";

// MapWrapper previously forced absolute + 100dvh defaults, which is correct for full-screen CareMap
// routes but causes embedded uses (like /scmap post-conversation) to escape their card and fill the viewport.
// The embedded flag keeps full-screen defaults intact while letting embedded map instances inherit parent sizing.
const MapWrapper = ({ children, sx = {}, embedded = false }) => (
  <Box
    sx={{
      bgcolor: "common.white",
      position: embedded ? "relative" : "absolute",
      overflow: "hidden",
      ...(embedded
        ? { height: "100%" }
        : {
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            height: sx?.height || "100dvh",
            maxWidth: "960px",
            mx: "auto",
          }),
      width: "100%",
      display: "flex",
      flexDirection: "column",
      alignItems: "stretch",
      justifyContent: "flex-start",
      ...sx,
    }}
  >
    {children}
  </Box>
);

export default MapWrapper;
